<template>
  <section class="section-component">
    <div class="container">
      <div v-if="title || link" class="section-component__header">
        <div class="section-component__header-left">
          <h2
            v-if="title"
            :class="{
              'section-component__title--clickable': link && isTitleClickable,
            }"
            class="text-h3 text-color-navy section-component__title"
            @click.prevent="link && isTitleClickable ? navigateTo(link.link) : null"
            v-html="title"
          />
          <p v-if="subtitle" class="section-component__subtitle text-paragraph" v-html="subtitle" />
        </div>
        <div class="section-component__header-right">
          <p v-if="total" class="section-component__total">{{ total }} Results</p>
          <particle-link
            v-if="link && isDesktop"
            :entryFields="link"
            :class="{ 'section-component__router-link': total }"
            class="section-component__link"
          />
        </div>
      </div>
      <div v-if="description" class="rich-text-wrapper section-component__description">
        <RichRenderer :richTextData="description" />
      </div>
      <div class="section-component__main">
        <slot />
      </div>
      <div v-if="showBottomActions" class="section-component__bottom-actions">
        <particle-link
          v-if="link"
          :entryFields="{
            ...link,
            representation: 'Link',
            buttonSize: 'Medium',
          }"
          class="section-component__link"
        />
      </div>
    </div>
  </section>
</template>
<script>
import ParticleLink from '@/components/common/ParticleLink.vue'

import { useNavigation } from '@/composables/useNavigation'
import { useScreenWidth } from '@/composables/useScreenWidth'

export default {
  name: 'SectionComponent',
  components: {
    ParticleLink,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    isTitleClickable: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    link: {
      type: Object,
      default: () => {},
    },
    description: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const { navigateTo } = useNavigation()
    const { isDesktop } = useScreenWidth()

    return {
      navigateTo,
      isDesktop,
    }
  },
  computed: {
    showBottomActions() {
      return !this.isDesktop && this.link
    },
  },
}
</script>
